// Touch feedback: phones have no hover, so a tap marks the touched link with data-tapped for a short Gletscherblau flash.
const selector = '.ma-social, footer .ft-link, s-header-nav a, s-header-nav summary';
document.addEventListener('pointerdown', (event) => {
  if (event.pointerType === 'mouse') return;
  const target = event.target instanceof Element ? event.target.closest(selector) : null;
  if (!target) return;
  target.setAttribute('data-tapped', '');
  setTimeout(() => target.removeAttribute('data-tapped'), 450);
}, { passive: true });

// Phones: the collections entry in the menu sheet folds open and closed with its + toggle.
document.addEventListener('click', (event) => {
  const toggle = event.target instanceof Element ? event.target.closest('[data-mm-toggle]') : null;
  if (!toggle) return;
  event.preventDefault();
  const item = toggle.closest('li');
  const open = !item.hasAttribute('data-mm-open');
  item.toggleAttribute('data-mm-open', open);
  toggle.setAttribute('aria-expanded', String(open));
});
